export const TipStevilkeEnum = {
  NI_DOLOCENO: '0',
  TELEFON: '1',
  FAKS: '2',
  NC: '3',
  ALARM: '4',
  UMTS: '5',
  POS: '6'
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/TipStevilkeEnum.js